import React from "react";

import styles from "./styles.m.css";
import { DfpAd } from "../dfp-ad";

const HeaderAdUnit = () => {
  return (
    <div className={styles["header-ad-unit"]}>
      <DfpAd adtype="Large_Leaderboard" placement="all" />
    </div>
  );
};

export default HeaderAdUnit;
